import "./previousEncounters.sass";
import { formatDateOnly } from "../dateHelpers";
import { openLink } from "../../../../../functions/functions";

export default function PreviousEncounters({ 
  headToHeadStats = null,
  headToHeadMatches = [],
  homeTeamName = "Local",
  awayTeamName = "Visitante",
}) {
  if (!headToHeadStats || headToHeadMatches.length === 0) {
    return (
      <div className="previous-encounters-container">
        <div className="empty-message">No hay historial de encuentros</div>
      </div>
    );
  }

  return (
    <div className="previous-encounters-container">
      {/* Estadísticas generales */}
      <div className="h2h-stats">
        <div className="stat-box">
          <div className="stat-value">{headToHeadStats.homeWins}</div>
          <div className="stat-label">Victorias {homeTeamName}</div>
        </div>

        <div className="stat-box">
          <div className="stat-value">{headToHeadStats.homeGoals}</div>
          <div className="stat-label">Goles {homeTeamName}</div>
        </div>

        <div className="stat-box">
          <div className="stat-value">{headToHeadStats.draws}</div>
          <div className="stat-label">Empates</div>
        </div>

        <div className="stat-box">
          <div className="stat-value">{headToHeadStats.awayWins}</div>
          <div className="stat-label">Victorias {awayTeamName}</div>
        </div>

        <div className="stat-box">
          <div className="stat-value">{headToHeadStats.awayGoals}</div>
          <div className="stat-label">Goles {awayTeamName}</div>
        </div>
      </div>

      {/* Últimos encuentros */}
      <div className="previous-matches">
        <div className="matches-list">
          {headToHeadMatches.slice(0, 10).map((match) => (
            <div key={match.id_juego} className="match-row-minuto" onClick={() => openLink(match.opta_event_url, true)}>
              <div className="match-infoComplete">
                <div className="match-date">
                  {formatDateOnly(match.date)}
                </div>

                <div className="match-competition">
                  {match.competition_name}
                </div>
              </div>

              <div className="match-result">
                <span className="team-name team-left">{match.home_name}</span>
                  <div className="match-score">
                    <span className="score">{match.home_score}</span>
                    <span className="vs">-</span>
                    <span className="score">{match.away_score}</span>
                  </div>
                <span className="team-name team-right">{match.away_name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}